import {
  Box,
  Button,
  IconButton,
  Modal,
  Typography,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import MailIcon from "@mui/icons-material/Mail";
import PhoneIcon from "@mui/icons-material/Phone";
import WcIcon from "@mui/icons-material/Wc";
import CelebrationIcon from "@mui/icons-material/Celebration";
import CakeIcon from "@mui/icons-material/Cake";
import InstagramIcon from "@mui/icons-material/Instagram";
import RollerSkatingIcon from "@mui/icons-material/RollerSkating";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
// import { ReactComponent as Store } from "../../assets/store.svg";
import { style, TransactionCard } from "../../styles/styledComponent";
import { Close, Edit } from "@mui/icons-material";
import { getProfile, updateProfile } from "../../service/profile";
import useAuth from "../../hooks/useAuth";
import moment from "moment";
import useAppConfig from "../../hooks/useAppConfig";
import {
  isProfileSurveyEnabled,
  onProfileClickRedirect,
  isCustomProfileSurveyEnabled,
  onCustomProfileSurveyClickRedirect,
  customSurveyTitle,
} from "../../shared/components/ListOfLinks";
import QrCodeIcon from "@mui/icons-material/QrCode";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import QRCodeDialog from "./QRCode";
import BarCodeDialog from "./BarCode";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import AdditionalTextContent from "./AdditionalText";
import _, { startCase } from "lodash";
import toast from "react-hot-toast";
import SurveyForm from "../DynamicForm/survey";
import util from "../../service/util";
import { PWAEnrollmentFields, USER_PWAEnrollmentFields, userProfileMap } from "../DynamicForm/constants";

const dateFormatFields = ["anniversary", "dob"];

const icons = {
  mobile: <PhoneIcon />,
  email: <MailIcon />,
  dob: <CakeIcon />,
  gender: <PeopleAltIcon />,
  maritalStatus: <WcIcon />,
  anniversary: <CelebrationIcon />,
  shoeSizes: <RollerSkatingIcon />,
  instagramId: <InstagramIcon />,
  children : <FamilyRestroomIcon/>
}


const UserProfile = () => {
  const [isEdit, setIsEdit] = useState(false);
  const pwaConfig = useAppConfig();
  const [isQRCode, setIsQRCode] = useState(false);
  const [isBarCode, setIsBarCode] = useState(false);
  const isAdditionalText = _.get(pwaConfig, "appConfig.config.additionalText.ALL_PAGES.html") === "<p><br></p>";

  const auth = useAuth();
  const [profile, setProfile] = useState({
    mobile: "",
  });
  const [initialBusinessData, setInitialBusinessData] = useState();




  const callApiProfile = () => {
    getProfile().then((res) => {
      let businessUnitData = { ...res.userBusinessUnit };
      delete businessUnitData._timestamp;
      setInitialBusinessData(res.userBusinessUnit);
      const updatedProfile = {
        ...res,
        ...util.processCdfFields(util.extractCustomBusinessFields(res.userBusinessUnit), "toDate"),
        ...util.convertFieldsToDate(res,["anniversary","dob"]),        
      };
      setProfile(updatedProfile);
    });
  };

  useEffect(() => {
    callApiProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setIsEdit(false);
    callApiProfile();
  };
  const handleUpdate = (rawData) => {
  const values = Object.keys(rawData)
    .filter((key) => PWAEnrollmentFields.includes(key))
    .reduce((obj, key) => {
      obj[key] = rawData[key];
      return obj;
    }, {});
  const userFields = Object.keys(rawData)
    .filter((key) => USER_PWAEnrollmentFields.includes(key))
    .reduce((obj, key) => {
      obj[key] = rawData[key];
      return obj;
    }, {});
    const updatedData = {
      data: {
        ...util.nestCustomFields(userFields),
        customerMobile: values.mobile,
        customerName: values.name,
        dob: values.dob && util.formatDateToISO(values.dob),
        anniversary:
          values.anniversary && util.formatDateToISO(values.anniversary),
        gender: values.gender,
        email: values.email,
        maritalStatus: values.maritalStatus,
      },
      businessData: {
          ...initialBusinessData,
          ...util.extractCustomBusinessFields(values),
          ...util.processCdfFields(util.extractCustomBusinessFields(values), "toIso"),
          name: values.name,
          email: values.email,
          tenant: auth?.user?.tenantId,
          businessUnit: auth?.user?.business,
        },
      tenant: auth?.user?.tenantId,
    };
    updateProfile(updatedData)
      .then(() => toast.success("Profile Updated Successfully"))
      .catch((err) => toast.error(err.message));
    setIsEdit(false);
  };

  const maskEmail = (email) => {
    if(email?.split("@").length === 1) {
      return email
    }
    const [localPart, domainPart] = email?.split("@") || "";

    const maskedLocal =
      localPart?.length > 1
        ? localPart.slice(0, 1) +
          "x".repeat(localPart.length - 1)
        : localPart;

    const [domainName, domainTLD] = domainPart?.split(".") || "";
    const maskedDomain =
      domainName?.length > 1
        ? domainName.slice(0, 1) +
          "x".repeat(domainName.length - 1) +
          "." +
          domainTLD
        : domainName + "." + domainTLD;

    return `${maskedLocal}@${maskedDomain}`;
  };

  const getValue = (name, value) => {
    if(dateFormatFields.includes(name)) {
      return value ? moment(`${value}`).format("DD-MM-YYYY") || "Not Available" : "Not Available";
    }
    if(name === "mobile" && value?.length) {
      return value.slice(0, 2) + 'x'.repeat(value.length - 4) + value.slice(-2);
    }
    if(name === "email") {
      return value ? maskEmail(value) : "Not Available";
    }
    return value || "Not Available";
  }


  return (
    <>
      <TransactionCard className="userProfile">
        <Typography fontWeight={800} fontSize={20} sx={{ textAlign: "center" }}>
          Hi, {profile.name || "User"} !
        </Typography>
        <Edit
          className="editIcon"
          fontSize="small"
          onClick={() => setIsEdit(true)}
        />
        <Box className="profile">
          {Object.entries(profile).map(([name, value], i) => {
          const fieldName = name === "dob" ? "birthday" : name
          const field = userProfileMap.find((field) => field.name === fieldName);
          if(name === "NikeComponent") {
              return "";
            }
            if (name !== "name" && field && name !== "children") {
             console.log("field",field);
              return (
                <Box className="profileContent" key={i}>
              <Typography color="primary" className="profileIcon">{icons[name] || ""}</Typography>
                  <Box className="profileContainer" key={name}>
                    <Typography color="primary" className="profileBox">
                      {startCase(field?.label.toLocaleLowerCase())}
                    </Typography>
                    <Typography>{getValue(name, value)}</Typography>
                  </Box>
                </Box>
              );
            }
            if (name === "children") {
              const childrenNames =
                value?.numberOfChildren === 0
                  ? "-"
                  : value?.numberOfChildren == null &&
                      value?.childrenDetails == null
                    ? "Not Available"
                    : value?.childrenDetails?.map((d) => d.name).join(", ") ||
                      "N/A";

              return (
                <Box className="profileContent" key={i}>
                  <Typography color="primary" className="profileIcon">
                    {icons[name] || ""}
                  </Typography>
                  <Box className="profileContainer" key={name}>
                    <Typography color="primary" className="profileBox">
                      {startCase("Children ".toLocaleLowerCase())}
                    </Typography>
                    <Typography>{childrenNames}</Typography>
                  </Box>
                </Box>
              );
            }
            return "";
          })}
        </Box>
        <Box className="buttonContainer">
          <Button
            variant="outlined"
            startIcon={<QrCodeIcon color="primary" />}
            onClick={() => setIsQRCode(true)}
            className="defaultButton"
          >
            Show QR Code to Cashier
          </Button>
          <Button
            variant="outlined"
            startIcon={<ViewWeekIcon color="primary" />}
            onClick={() => setIsBarCode(true)}
            className="defaultButton"
          >
            Show Bar Code to Cashier
          </Button>
          {isProfileSurveyEnabled(pwaConfig) && (
            <Button
              variant="outlined"
              startIcon={<DriveFileRenameOutlineIcon color="primary" />}
              onClick={() => onProfileClickRedirect(pwaConfig, auth)}
              className="defaultButton"
            >
              Complete Profile
            </Button>
          )}
          {isCustomProfileSurveyEnabled(pwaConfig) && (
            <Button
              variant="outlined"
              startIcon={<FeedbackOutlinedIcon color="primary" />}
              onClick={() =>
                onCustomProfileSurveyClickRedirect(pwaConfig, auth)
              }
              className="defaultButton"
            >
              {customSurveyTitle(pwaConfig)?.length > 15 ? (
                <Tooltip title={customSurveyTitle(pwaConfig)} placement="top">
                  <span>{`${customSurveyTitle(pwaConfig).substring(0, 12)}...`}</span>
                </Tooltip>
              ) : (
                customSurveyTitle(pwaConfig)
              )}
            </Button>
          )}
        </Box>
      </TransactionCard>

      {isQRCode && <QRCodeDialog onClose={() => setIsQRCode(false)} mobile={profile.mobile} />}
      {isBarCode && <BarCodeDialog onClose={() => setIsBarCode(false)} mobile={profile.mobile} />}

      <Modal open={isEdit} onClose={handleClose}>
        <Box sx={style}>
          <IconButton
            style={{ position: "absolute", top: 10, right: 20 , zIndex:1 }}
            onClick={handleClose}
          >
            <Close />
          </IconButton>
           <SurveyForm onCompleting={handleUpdate} isEdit={true} initialValues={profile}/>
        </Box>
      </Modal>
      {!isAdditionalText && <AdditionalTextContent />}
    </>
  );
};

export default UserProfile;
